import { render, staticRenderFns } from "./goverment-search-all.vue?vue&type=template&id=9dcee2ea&scoped=true"
import script from "./goverment-search-all.vue?vue&type=script&lang=js"
export * from "./goverment-search-all.vue?vue&type=script&lang=js"
import style0 from "./goverment-search-all.vue?vue&type=style&index=0&id=9dcee2ea&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dcee2ea",
  null
  
)

export default component.exports